import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import {
  MockUseRecordType1
} from '@/views/dashboard/manage/genuine-software-usage/_components/software-view/_components/rank-card/_mocks/use-record-type1'
import {
  MockUseRecordType2
} from '@/views/dashboard/manage/genuine-software-usage/_components/software-view/_components/rank-card/_mocks/use-record-type2'
import {
  MockUseRecordType3
} from '@/views/dashboard/manage/genuine-software-usage/_components/software-view/_components/rank-card/_mocks/use-record-type3'

export interface RequestParams {
  end_time?: string
  soft_group_id?: number
  soft_name?: string
  start_time?: string
  /** 统计类型 1-使用时长统计 2-使用次数统计 3-使用终端数统计 */
  type?: number
  /** 是否只查正版软件 0-全部 1-是 */
  authenticsoft_flag?: number
  is_mock?: boolean
}

export interface RankData {
  /** 数值 */
  value: number
  /** 名称 */
  name?: string
}

@Injectable()
export class RankCardService {
  constructor (private http: Http) {
  }


  getRankData (data: RequestParams) {
    if (data.is_mock) {
      if (data.type === 1) {
        return Promise.resolve(MockUseRecordType1)
      } else if (data.type === 2) {
        return Promise.resolve(MockUseRecordType2)
      } else if (data.type === 3) {
        return Promise.resolve(MockUseRecordType3)
      }
    }

    return this.http.post<{view_infos: RankData[]}>('/softmgr/userecord/soft', data)
  }
}
